import { useMemo } from "react";
import { useQuery } from "react-query";

import { aircraftAvailabilityQueryKeys, getAircraftAvailabilityWindows } from "./aircraftAvailabilityApi";
import { normalizeAircraftRegistrations } from "./aircraftAvailabilityConstraints";

const AVAILABILITY_WINDOW_STALE_TIME = 60 * 1000;
const AVAILABILITY_WINDOW_CACHE_TIME = 5 * 60 * 1000;
const EMPTY_WINDOWS_BY_REGISTRATION = {};

export function useAircraftAvailabilityWindows(
    { registrations = [], start, end, status = "ACTIVE" } = {},
    options = {},
) {
    const normalizedRegistrations = useMemo(
        () => normalizeAircraftRegistrations(registrations),
        [registrations],
    );
    const { enabled: enabledOption = true, ...queryOptions } = options;
    const enabled = Boolean(enabledOption && normalizedRegistrations.length && start && end);
    const query = useQuery(
        aircraftAvailabilityQueryKeys.windows(normalizedRegistrations, start, end, status),
        () => getAircraftAvailabilityWindows({
            registrations: normalizedRegistrations,
            start,
            end,
            status,
        }),
        {
            enabled,
            staleTime: AVAILABILITY_WINDOW_STALE_TIME,
            cacheTime: AVAILABILITY_WINDOW_CACHE_TIME,
            refetchOnWindowFocus: false,
            ...queryOptions,
        },
    );

    return {
        windowsByRegistration: query.data || EMPTY_WINDOWS_BY_REGISTRATION,
        isLoading: query.isLoading,
        loading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error,
        dataUpdatedAt: query.dataUpdatedAt,
        refetch: query.refetch,
    };
}

export default useAircraftAvailabilityWindows;
